// import * as QueryString from "query-string";
export class QuerystringHelper {
    public static readonly OBJECT_TYPE = "[object Object]";
    public static readonly ARRAY_TYPE = "[object Array]";

    public static toQuerystring(obj: any, path?: string, result?: any) {
        const type = toString.call(obj);
        if (result === undefined) {
            if (type === this.OBJECT_TYPE) {
                result = {};
            } else if (type === this.ARRAY_TYPE) {
                result = [];
            } else {
                return;
            }
        }

        const qs = this.flatten(obj, path, result);
        return Object.keys(qs).map(key => key + '=' + qs[key]).join('&');
    }

    public static appendToUrl(url: string, paramName: string, paramVal: string): string {
        const seperator = url.indexOf('?') === -1 ? '?' : '&';
        return `${url}${seperator}${paramName}=${paramVal}`;
    }

    // public static ExtractRouteLocationQueryParams(location: any): any {
    //     return QueryString.parse(location.search);
    // }

    private static flatten(obj: any, path?: string, result?: any, parentIsArray?: boolean) {
        const { toString, hasOwnProperty } = Object.prototype;

        for (const key in obj) {

            if (!hasOwnProperty.call(obj, key)) {
                continue;
            }

            const val = obj[key];
            if (val == null) {
                continue;
            }

            switch (toString.call(val)) {
                case this.ARRAY_TYPE:
                    this.flatten(val, this.joinDot(path, key), result, true);
                    break;
                case this.OBJECT_TYPE:
                    if (parentIsArray) {
                        this.flatten(val, this.joinArray(path, key), result);
                    } else {
                        this.flatten(val, this.joinDot(path, key), result);
                    }
                    break;
                default:
                    if (parentIsArray) {
                        result[this.joinArray(path, key)] = val;
                    } else {
                        result[this.joinDot(path, key)] = val;
                    }
                    break;
            }
        }

        return result;
    }

    private static joinDot(path: string | void, key: string) {
        return path != null ? path + '.' + key : key;
    }

    private static joinArray(path: string | void, key: string) {
        return path != null ? path + '[' + key + ']' : key;
    }
}
